import _defineProperty from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _defineStyle, _defineStyle2;
// src/components/form-error.ts
import { formErrorAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $fg = cssVar("form-error-color");
var baseStyleText = defineStyle((_defineStyle = {}, _defineProperty(_defineStyle, $fg.variable, "colors.red.500"), _defineProperty(_defineStyle, "_dark", _defineProperty({}, $fg.variable, "colors.red.300")), _defineProperty(_defineStyle, "color", $fg.reference), _defineProperty(_defineStyle, "mt", "2"), _defineProperty(_defineStyle, "fontSize", "sm"), _defineProperty(_defineStyle, "lineHeight", "normal"), _defineStyle));
var baseStyleIcon = defineStyle((_defineStyle2 = {
  marginEnd: "0.5em"
}, _defineProperty(_defineStyle2, $fg.variable, "colors.red.500"), _defineProperty(_defineStyle2, "_dark", _defineProperty({}, $fg.variable, "colors.red.300")), _defineProperty(_defineStyle2, "color", $fg.reference), _defineStyle2));
var baseStyle = definePartsStyle({
  text: baseStyleText,
  icon: baseStyleIcon
});
var formErrorTheme = defineMultiStyleConfig({
  baseStyle: baseStyle
});
export { formErrorTheme };